var React = require('react');

function IconLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M13.4549 5.08502L1.6103 11.7635L1.60998 11.7633C1.4042 11.8794 1.27361 12.0971 1.2681 12.3342C1.2626 12.5713 1.38269 12.792 1.58296 12.913L13.1034 19.8676C13.1233 19.8796 13.1434 19.8906 13.164 19.9002C13.3526 19.9882 13.5744 19.9802 13.7602 19.8755C13.9661 19.759 14.0967 19.5414 14.1022 19.3043L14.219 14.4058L12.9196 13.7993L12.8164 18.1391L3.23908 12.3579L13.0858 6.80594L13.0077 10.0869H13.005V10.1988L12.9966 10.5534L13.005 10.5573V11.3681H21.9737C22.3275 11.3681 22.6143 11.0813 22.6143 10.7275C22.6143 10.3737 22.3275 10.0869 21.9737 10.0869H14.3216L14.4265 5.67172C14.432 5.4346 14.3119 5.2139 14.1116 5.09292C13.9113 4.97193 13.6607 4.96888 13.4549 5.08502Z","fill":"black"}));
}

IconLeft.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = IconLeft;

IconLeft.default = IconLeft;
